// 要素とリンク線の接続箇所のマージン（矢印などのマークがめり込まないために設定するマージン）
export const ConnectionPointMargin = 24;
export const LineEdgeArrowMarkSize = 32;
export const LineEdgeDiamondMarkSize = 40;
